
import { GAME_FACT_BASKET_STOP, GAME_FACT_HANDBALL_GOAL, GAME_FACT_HANDBALL_PENALTY, GAME_FACT_HANDBALL_STOP, GAME_FACT_REDCARD, GAME_FACT_REPLACEMENT, GAME_FACT_RUGBY_STOP, GAME_FACT_SOCCER_BUT, GAME_FACT_SOCCER_PENALTY, GAME_FACT_SOCCER_REDCARD, GAME_FACT_SOCCER_REPLACEMENT, GAME_FACT_SOCCER_STOP, GAME_FACT_START } from "../data/constants";
import { createNotation, createSurvey } from "./importBuilder";
import { NOTATION_MATCH, NOTATION_PLAYER, SURVEY_PRONOSTIC, SURVEY_YES_NO } from "./importConstants";

export const getTriggerBuild = (createdGameFact, match) => {

    // On switch sur le type du gamefact
    switch(createdGameFact.type){
        case GAME_FACT_SOCCER_BUT:
        case GAME_FACT_SOCCER_PENALTY:
            // si validé - Sondage automatique - Le score va t il évoluer ? oui/non
            if(Boolean(createdGameFact.detail.butSucced) || Boolean(createdGameFact.detail.penalitySucced)){
                return createSurvey(SURVEY_YES_NO, {
                    idMatch : match.idMatch,
                    period : createdGameFact.period,
                    timer : createdGameFact.timer,
                    displayDate : createdGameFact.displayDate,
                    question : "Selon vous, suite à ce but, le score de la rencontre va-t-il évoluer ?",
                })
            }
        break
        case GAME_FACT_SOCCER_REDCARD:
            //Sondage automatique - Le score va t il évoluer ? oui/non
            return createSurvey(SURVEY_YES_NO, {
                    idMatch : match.idMatch,
                    period : createdGameFact.period,
                    timer : createdGameFact.timer,
                    displayDate : createdGameFact.displayDate,
                    question : "Selon vous, suite à ce carton rouge, le score de la rencontre va-t-il évoluer ?",
            })
        break
        case GAME_FACT_REDCARD:
            //Sondage automatique - Le score va t il évoluer ? oui/non
            return createSurvey(SURVEY_YES_NO, {
                    idMatch : match.idMatch,
                    period : createdGameFact.period,
                    timer : createdGameFact.timer,
                    displayDate : createdGameFact.displayDate,
                    question : "Selon vous, suite à ce carton rouge, le résultat de la rencontre va-t-il évoluer ?",
            })
        break
        case GAME_FACT_SOCCER_REPLACEMENT:
        case GAME_FACT_REPLACEMENT:
            // si joueur sortant - Notation automatique du joueur sortant
            return createNotation(NOTATION_PLAYER,{
                idMatch : match.idMatch,
                period : createdGameFact.period,
                timer : createdGameFact.timer,
                displayDate : createdGameFact.displayDate,
                idPlayer : createdGameFact.detail.outplayer, 
                idTeam : createdGameFact.detail.team
            })
        break
        case GAME_FACT_START:
            // On doit recupérer le match en bdd pour connaitre les équipes concernées et balancer un sondage pronostic
            return createSurvey(SURVEY_PRONOSTIC, {
                    idMatch : match.idMatch,
                    period : createdGameFact.period,
                    timer : createdGameFact.timer,
                    displayDate : createdGameFact.displayDate,
                    question : "Quel est votre pronostic pour cette rencontre ?",
                    isPin : true,
                    match
            })
        case GAME_FACT_SOCCER_STOP:
        case GAME_FACT_RUGBY_STOP:
        case GAME_FACT_BASKET_STOP:
        case GAME_FACT_HANDBALL_STOP:
            // On doit recupérer le match en bdd pour connaitre les équipes concernées et balancer un sondage pronostic
            if(['next'].includes(createdGameFact.detail.reason)){
                return createSurvey(SURVEY_PRONOSTIC, {
                        idMatch : match.idMatch,
                        period : createdGameFact.period,
                        timer : createdGameFact.timer,
                        displayDate : createdGameFact.displayDate,
                        question : "Quel va être le résultat final de ce match ?",
                        isPin : false,
                        match
                })
            }else if(['end'].includes(createdGameFact.detail.reason)){
                return createNotation(NOTATION_MATCH,{
                    idMatch : match.idMatch,
                    period : createdGameFact.period,
                    timer : createdGameFact.timer,
                    displayDate : createdGameFact.displayDate,
                })
            }
            
    }
}